import { DATABASE_NAME } from '@env'
import { collection, onSnapshot } from 'firebase/firestore'
import { db } from '../../firebase/config'
import '../../global'
import { Collection } from '../firebase.enums'
import { transformFirestoreResponse } from '../utils/firestoreTransform'
import { firestoreGet } from '../../utils/firestoreApi'

// export const getOrgCuisinesData = async () => {
// 	const querySnapshot = await getDocs(
// 		collection(db, DATABASE_NAME, global.org, Collection.Cuisines)
// 	)
// 	querySnapshot.forEach(doc => {
// 		// doc.data() is never undefined for query doc snapshots
// 		console.log(doc.id, ' => ', doc.data())
// 	})
// }

export const getOrgCuisinesData = () => {
	return new Promise((resolve, reject) => {
		const dataImport = {}
		const cuisinesRef = collection(db, DATABASE_NAME, global.org, Collection.Cuisines)

		if (!dataImport['orgCuisines']) {
			dataImport['orgCuisines'] = []
		}
		onSnapshot(
			cuisinesRef,
			snapshot => {
				snapshot.docChanges().forEach(change => {
					const data = change.doc.data()
					if (!data.isDeleted) {
						dataImport['orgCuisines'].push({
							id: change.doc.id,
							ordinal: data.ordinal,
							imageUrl: data.imageUrl,
							title: data.title || change.doc.id,
						})
					}
				})

				resolve(dataImport)
			},
			reject
		)
	})
}

export const getOrgCuisineDataForBot = () => {
	const endpoint = `Organizations-v2/${global.org}/Cuisines`

	return firestoreGet(endpoint)
		.then(rawData => {
			const dataImport = { orgCuisines: [] }

			if (rawData.documents && rawData.documents.length > 0) {
				rawData.documents.forEach(data => {
					const transformedData = transformFirestoreResponse(data)

					if (!transformedData.isDeleted) {
						dataImport.orgCuisines.push({
							id: transformedData.id,
							ordinal: transformedData.ordinal,
							imageUrl: transformedData.imageUrl,
							title: transformedData.title || transformedData.id,
						})
					}
				})
			} else {
				console.log('No org cuisines documents found in response')
			}

			return dataImport
		})
		.catch(error => {
			console.error('Error fetching org cuisine data:', error)
			throw error
		})
}
